<template>
  <CCard>
    <CCardHeader class="d-sm-flex justify-content-between align-items-center">
      {{ news.title }}
      <div v-if="$type === 'MANAGER'" class="d-flex mt-3 mt-sm-0">
        <CButton
            :disabled="loading"
            class="px-4 px-sm-5 flex-fill"
            color="primary "
            @click="newsRemoveModal = true"
        >
          <CIcon name="cil-trash"/>
          حذف
        </CButton>
        <RemoveNewsModal v-model="newsRemoveModal" :news="news"/>
        <CButton
            class="px-4 px-sm-5 mr-2 flex-fill"
            color="secondary"
            @click="editNewsModal = true"
        >
          <CIcon name="cil-pen"/>
          ویرایش
        </CButton>
        <EditNewsModal
            v-model="editNewsModal"
            :news="news"
            @get-news="getNewsById"
        />
      </div>
    </CCardHeader>
    <CCardBody class="d-flex flex-column align-items-center text-center h-100">
      <img :src="news.bannerImageUrl" alt="" class="banner-image"/>
      <div class="mt-4 w-100 d-flex justify-content-between align-items-center">
        <div class="primary text-sm">#{{ news.tag.name }}</div>
        <div class="text-sm gray-700">{{ addDate }}، {{ addTime }}</div>
      </div>
      <div class="desc text-justify mt-4">{{ news.text }}</div>
      <div>
        <div v-if="filterVideos.length">
          <video
              v-for="(video, index) in filterVideos"
              :key="index"
              class="media-video__wrapper mt-4 w-100"
              controls
          >
            <source :src="video"/>
          </video>
        </div>
        <div v-if="filterAudios.length">
          <audio
              v-for="(audio, index) in filterAudios"
              :key="index"
              class="media-audio__wrapper mt-4 w-100"
              controls
          >
            <source :src="audio"/>
          </audio>
        </div>
        <div v-if="filterImages.length" class="media-image__wrapper">
          <img
              v-for="(image, index) in filterImages"
              :key="index"
              :src="image"
              alt=""
              class="mx-2 mt-4"
          />
        </div>
      </div>
      <div
          class="
          w-100
          d-flex
          justify-content-center
          flex-wrap
          align-items-center
          mt-4
        "
      >
        <div
            v-for="(file, index) in news.fileUrls"
            :key="index"
            class="download-file mb-3 ml-2"
        >
          <a :href="file" download="" target="_blank">
            <CIcon name="cil-file"/>
          </a>
        </div>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import axios from "@/plugins/axios";
import EditNewsModal from "@/components/Modals/News/EditNewsModal.vue";
import RemoveNewsModal from "@/components/Modals/News/RemoveNewsModal.vue";

export default {
  components: {
    EditNewsModal,
    RemoveNewsModal,
  },
  name: "news",
  data() {
    return {
      news: {},
      loading: false,
      editNewsModal: false,
      newsRemoveModal: false,
    };
  },
  computed: {
    addDate() {
      return this.news.addDate
          .split(" ")
          .slice(0, 1)
          .toString()
          .split("-")
          .join("/");
    },
    addTime() {
      return this.news.addDate.split(" ").slice(1, 2).toString();
    },
    filterImages() {
      return this.news.mediaUrls.filter(
          (item) =>
              item.toLowerCase().includes("jpg") ||
              item.toLowerCase().includes("png") ||
              item.toLowerCase().includes("jpeg") ||
              item.toLowerCase().includes("bmp") ||
              item.toLowerCase().includes("tiff") ||
              item.toLowerCase().includes("gif") ||
              item.toLowerCase().includes("svg")
      );
    },
    filterVideos() {
      return this.news.mediaUrls.filter(
          (item) =>
              item.toLowerCase().includes("mp4") ||
              item.toLowerCase().includes("mkv") ||
              item.toLowerCase().includes("avi") ||
              item.toLowerCase().includes("mov") ||
              item.toLowerCase().includes("webm") ||
              item.toLowerCase().includes("flv")
      );
    },
    filterAudios() {
      return this.news.mediaUrls.filter(
          (item) =>
              item.toLowerCase().includes("mp3") ||
              item.toLowerCase().includes("ogg") ||
              item.toLowerCase().includes("m4a") ||
              item.toLowerCase().includes("aac") ||
              item.toLowerCase().includes("wav")
      );
    },
  },
  beforeMount() {
    this.getNewsById();
  },

  methods: {
    async getNewsById(routeName) {
      try {
        this.loading = true;
        const {id: newsId} = this.$route.params;
        const {data} = await axios.get(`/news/${newsId}`);
        this.news = data;
        routeName = `${data.title}`;
        this.$emit("go-to", routeName);
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-image {
  width: 100%;
  height: 256px;
  object-fit: cover;
  border-radius: 8px;
}

.desc {
  word-wrap: break-word;
  white-space: pre-line;
  line-height: 1.75;
}

.media-image__wrapper {
  width: 100%;

  img {
    // min-width: 25%;
    max-width: 75%;
    height: auto;
    object-fit: cover;
    border-radius: 8px;
    @media (max-width: 768px) {
      min-width: 100%;
      max-width: 100%;
    }
  }
}

.media-video__wrapper {
  border-radius: 8px;
}

.download-file {
  display: inline-block;
  width: 156px;
  height: 65px;
  border: 1px solid #9da5b1;
  color: #9da5b1;
  text-align: center;
  line-height: 65px;
  cursor: pointer;
  border-radius: 8px;

  .c-icon {
    width: 2rem;
    height: 2rem;
  }
}
</style>